if (!customElements.get('w-drawer')) {
  class WDrawer extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.panel = this.querySelector('.w-drawer__panel');

      this.querySelectorAll('[data-w-drawer-close]').forEach((el) => {
        el.addEventListener('click', () => this.close(), { signal });
      });
      this.addEventListener('click', (event) => {
        if (event.target === this) this.close();
      }, { signal });
      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

      if (this.panel) {
        this.panel.addEventListener('transitionend', (event) => {
          if (event.target === this.panel && !this.classList.contains('is-open')) this.hidden = true;
        }, { signal });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      }, { signal });

      if (!window.__wDrawerInit) {
        window.__wDrawerInit = true;
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-w-drawer-open]');
          if (!trigger) return;
          const id = trigger.getAttribute('data-w-drawer-open');
          const drawer = id ? document.getElementById(id) : document.querySelector('w-drawer');
          if (!drawer || typeof drawer.open !== 'function') return;
          event.preventDefault();
          drawer.open(trigger);
        });
      }
    }

    disconnectedCallback() {
      this.close();
      this.controller?.abort();
    }

    open(trigger) {
      this.opener = trigger || null;
      this.hidden = false;
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('w-scroll-lock');
      void this.offsetWidth;
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.dispatchEvent(new CustomEvent('w-drawer:open', { bubbles: true }));
        const closeBtn = this.querySelector('.w-drawer__close');
        if (closeBtn) closeBtn.focus();
      });
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('w-scroll-lock');
      if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
      this.dispatchEvent(new CustomEvent('w-drawer:close', { bubbles: true }));
      if (this.hideTimer) clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      }, 350);
    }

    onKeydown(event) {
      if (event.key !== 'Tab' || !this.classList.contains('is-open')) return;
      const focusables = this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('w-drawer', WDrawer);
}
